import { PATIENT_MESSAGE_ATTENTION_SEARCH_KEY } from "@emr/contracts";

export interface AttentionSearch {
  report?: string;
  work?: string;
  result?: string;
  referral?: string;
  conversation?: string;
  /** A patient text or email that needs a person (PA-7), by message id. */
  patientMessage?: string;
  invalidSelection?: boolean;
}
const idPattern = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
const selections = [
  "report",
  "work",
  "result",
  "referral",
  "conversation",
  PATIENT_MESSAGE_ATTENTION_SEARCH_KEY,
] as const;
/** An Attention link selects one opaque record. Invalid selections remain visible as errors. */
export function validateAttentionSearch(search: Record<string, unknown>): AttentionSearch {
  const present = selections.filter((key) => search[key] !== undefined);
  if (present.length > 1) return { invalidSelection: true };
  const key = present[0];
  if (key !== undefined) {
    const value = search[key];
    return typeof value === "string" && idPattern.test(value)
      ? { [key]: value }
      : { invalidSelection: true };
  }
  return search.invalidSelection === true ? { invalidSelection: true } : {};
}
